function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col } from 'react-bootstrap';
import { Tabs, message, Skeleton, Button, Typography, Space, Select, Drawer, Descriptions, Input, Form, Modal, notification, DatePicker, Alert, Tag } from 'antd';
import { Table } from 'react-bootstrap';
import DisplayMultiplePage from "./DisplayMultiplePage";
import Common from "../components/includes/Common";
import Moment from "react-moment";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var SendList = function SendList() {
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isDataLoading = _useState2[0],
    setIsDataLoading = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    customers = _useState4[0],
    setCustomers = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    currentCustomer = _useState6[0],
    setCurrentCustomer = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    showCertificate = _useState8[0],
    setShowCertificate = _useState8[1];
  var ref = useRef();
  var loadData = function loadData() {
    setIsDataLoading(true);
    axios.get("".concat(Common.baseApiUrl, "gettosendlist/").concat(Common.currentUser.id)).then(function (response) {
      setCustomers(response.data.customers);
    })["catch"](function (error) {
      message.error({
        content: "Une erreur est survenue",
        delay: 4
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  };
  useEffect(function () {
    loadData();
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsxs(Col, {
          lg: 12,
          md: 12,
          children: [/*#__PURE__*/_jsxs(Table, {
            striped: true,
            bordered: true,
            hover: true,
            responsive: true,
            children: [/*#__PURE__*/_jsx("thead", {
              children: /*#__PURE__*/_jsxs("tr", {
                children: [/*#__PURE__*/_jsx("th", {
                  children: "TYPE"
                }), /*#__PURE__*/_jsx("th", {
                  children: "CODE"
                }), /*#__PURE__*/_jsx("th", {
                  children: "NOM"
                }), /*#__PURE__*/_jsx("th", {
                  children: "SOCIETE"
                }), /*#__PURE__*/_jsx("th", {
                  children: "ACTION"
                })]
              })
            }), /*#__PURE__*/_jsx("tbody", {
              children: customers.map(function (c) {
                return /*#__PURE__*/_jsxs("tr", {
                  children: [/*#__PURE__*/_jsx("td", {
                    children: c.candidate_code
                  }), /*#__PURE__*/_jsx("td", {
                    children: c.category != "0" && c.category
                  }), /*#__PURE__*/_jsx("td", {
                    children: c.name
                  }), /*#__PURE__*/_jsx("td", {
                    children: c.company.label
                  }), /*#__PURE__*/_jsx("td", {
                    children: /*#__PURE__*/_jsx(Space, {
                      direction: "horizontal",
                      children: /*#__PURE__*/_jsx(Button, {
                        type: "primary",
                        onClick: function onClick() {
                          setCurrentCustomer(c);
                          setShowCertificate(true);
                        },
                        children: /*#__PURE__*/_jsx("b", {
                          children: "VOIR LE CERTIFICAT"
                        })
                      })
                    })
                  })]
                }, c.id);
              })
            })]
          }), isDataLoading == true && /*#__PURE__*/_jsx(Skeleton, {
            active: true
          })]
        })
      })
    }), currentCustomer && /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(Drawer, {
        open: showCertificate,
        title: /*#__PURE__*/_jsx("b", {
          children: "CERTIFICAT D'APTITUDE"
        }),
        width: "90%",
        onClose: function onClose() {
          setShowCertificate(false);
        },
        extra: [],
        destroyOnClose: true,
        children: currentCustomer.conclusion && /*#__PURE__*/_jsx(DisplayMultiplePage, {
          pageCount: 1,
          file_url: currentCustomer.conclusion.file
        })
      })
    })]
  });
};
export default SendList;